import api from './client';

export interface ProjectComment {
  id: string;
  project_id: string;
  user_id: string;
  user_name: string | null;
  content: string;
  created_at: string;
  updated_at: string;
}

export async function listComments(projectId: string) {
  const res = await api.get<ProjectComment[]>(`/projects/${projectId}/comments`);
  return res.data;
}

export async function createComment(projectId: string, content: string) {
  const res = await api.post<ProjectComment>(`/projects/${projectId}/comments`, { content });
  return res.data;
}

export async function updateComment(commentId: string, content: string) {
  const res = await api.put<ProjectComment>(`/projects/comments/${commentId}`, { content });
  return res.data;
}

export async function deleteComment(commentId: string) {
  await api.delete(`/projects/comments/${commentId}`);
}
